import "bootstrap";

import $ from "jquery";
import "jquery.cookie";

import "../common/jquery.ajaxSetup";
import "../glyphicons/glyphicons.css";
import "./index.styl";

$(document).ready(() => {
  const domHeight = $(document).height();
  const windowHeight = $(window).height();
  if (domHeight === windowHeight) {
    // TODO: move this into responsive css
    $("#footer").css({ position: "fixed", bottom: "0" });
  }
  setTimeout(() => $(".flash-messages").fadeOut("slow"), 3000);
});
